export enum ROLE_TYPE {
  IDFOTP_NEWCUSTOMER = 'IDFOTP_NEWCUSTOMER',
  IDFOTP_NEWCUSTOMER_DONE = 'IDFOTP_NEWCUSTOMER_DONE',
  IDFOTP_NEWCUSTOMER_ERROR = 'IDFOTP_NEWCUSTOMER_ERROR',
  IDFOTP_CUSTOMEREXIST = 'IDFOTP_CUSTOMEREXIST',
  IDFOTP_CUSTOMER_EXIST_BEFOREACTIVE = 'IDFOTP_CUSTOMER_EXIST_BEFOREACTIVE',
}
